module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kj-Lb.6e39fa61.png";